/**
 * @file page-modal.component.tsx
 * @description Компонент полноэкранного модального окна для Task Manager приложения, который обеспечивает отображение страниц или крупных компонентов в модальном режиме с автоматическим определением контейнера. Управляет жизненным циклом модального окна, включая автоматический поиск контейнера MainLayout при отсутствии переданного контейнера, обработку состояний открытия и закрытия, а также передачу обработчика закрытия дочерним компонентам.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-16
 * @dependencies ['react', '@consta/uikit/Modal']
 * @related-files ['src/layouts/main-layout.tsx', 'src/features/catalog/catalog.component.tsx', 'src/features/chart/chart.component.tsx']
 */

import { HTMLAttributes, useState, ReactElement, useEffect } from 'react';
import { Modal } from '@consta/uikit/Modal';

/**
 * Props для компонента PageModal
 */
interface IPageModalProps extends HTMLAttributes<HTMLDivElement> {
    /** Дочерние элементы модального окна */
    children: ReactElement;
    /** HTML контейнер для портала */
    container?: HTMLDivElement;
    /** Флаг открытия модального окна */
    isOpen: boolean;
    /** Обработчик закрытия страницы с возможностью принудительного закрытия */
    closePageHandler: (isForce: boolean) => void;
}

export const PageModal = ({ container, children, closePageHandler, isOpen = true }: IPageModalProps) => {
    const [modalContainer, setModalContainer] = useState<HTMLDivElement | undefined>(container);

    useEffect(() => {
        setModalContainer(container || (document.getElementById('MainLayout') as HTMLDivElement));
    }, []);

    if (!modalContainer) {
        return <></>;
    }

    return (
        <Modal
            hasOverlay={false}
            className="w-full relative h-full page-modal"
            rootClassName="absolute"
            isOpen={isOpen}
            position="center"
            container={modalContainer}
            onEsc={() => closePageHandler(false)}
        >
            <div className="pageModal w-full h-full relative">{children}</div>
        </Modal>
    );
};